import { render, staticRenderFns } from "./tblPropCompCombined.vue?vue&type=template&id=0796b4d4&scoped=true"
import script from "./tblPropCompCombined.vue?vue&type=script&lang=js"
export * from "./tblPropCompCombined.vue?vue&type=script&lang=js"
import style0 from "./tblPropCompCombined.vue?vue&type=style&index=0&id=0796b4d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0796b4d4",
  null
  
)

export default component.exports